import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import DeleteIcon from '@commonComponents/deleteIcon'

const MerchDutyForm = ({
  dataSource: { id, taxType, taxBase, taxRate, mop, qty, uom, payableAmount, deferredAmount },
  deleteData,
  dropdownList,
  onBlur,
  onChange,
  onSelect,
  translate,
  tableName,
}) => {
  const onChangeHandler = useCallback(
    ({target: {value, name}}) => onChange(id, tableName, { [name]: value }),
    [tableName, id, onChange]
  )
  const onDropDownChange = useCallback(
    (e, {value, name}) => {
      onSelect(id, tableName, { [name]: value, id })
    },
    [tableName, id, onSelect]
  )
  const onBlurHandler = useCallback(
    ({target: {value, name}}) => onBlur(tableName, { [name]: value, id }),
    [tableName, id, onBlur]
  )
  return (
    <div className='formContainer'>
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id={`TaxType${id}`}
            labelClass='text-none'
            label={translate('TAX_TYPE', { ns: ['default', 'lineItem'] })}
            boxNumber='4/3'
            value={taxType}
            name='taxType'
            data={dropdownList}
            clearable
            onChange={onDropDownChange}
          />
        </Grid.Column>

        <Grid.Column>
          <InputField
            id={`taxBase${id}`}
            type='text'
            label={translate('DUTY/TAX BASE', { ns: ['default', 'lineItem'] })}
            value={taxBase}
            name='taxBase'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`taxRate${id}`}
            type='text'
            label={translate('TAX_RATE', { ns: ['default', 'lineItem'] })}
            value={taxRate}
            name='taxRate'
            boxNumber='4/5'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`dutyQty${id}`}
            type='text'
            label={translate('QTY', { ns: ['default', 'lineItem'] })}
            value={qty}
            name='qty'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`taxUom${id}`}
            type='text'
            label={translate('UOM', { ns: ['default', 'lineItem'] })}
            value={uom}
            name='uom'
            boxNumber='4/5'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`PAYABLE${id}`}
            type='text'
            label={translate('PAYABLE', { ns: ['default', 'lineItem'] })}
            value={payableAmount}
            name='payableAmount'
            boxNumber='4/6'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`deffered${id}`}
            type='text'
            label={translate('DEFFERED', { ns: ['default', 'lineItem'] })}
            value={deferredAmount}
            name='defferedAmount'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`MOP${id}`}
            type='text'
            label={translate('MOP', { ns: ['default', 'lineItem'] })}
            value={mop}
            name='mop'
            boxNumber='4/8'
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
      </Grid.Row>
      <div className='actionbtns'>
        <DeleteIcon onClick={() => deleteData(id, tableName)} />
      </div>
    </div>
  )
}
MerchDutyForm.defaultProps = {
  translate: (value) => value,
}
export default React.memo(MerchDutyForm)
